var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"Element",staticClass:"dropdown",style:(_vm.style),on:{"transitionend":_vm.onTransitionEnd}},[_c(_vm.contentTag,{ref:"content",tag:"Element",class:_vm.className},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }